// extracted by mini-css-extract-plugin
export default {"root":"PaymentLogic_root__BeBI6","example":"PaymentLogic_example__aJ84q","type":"PaymentLogic_type__YlQAN","days":"PaymentLogic_days__7QF67"};